import { GET_PARAMS } from "constants/popupConfig";
import makeUrl from "../../utils/make-url";
import config from "../config";

const routes = config.casino;

export const index = (...args) => makeUrl(routes.root, ...args);
export const favorites = (...args) =>
  makeUrl(`${routes.root}${routes.favorite}`, ...args);
export const category = (...args) => {
  return makeUrl(`${routes.root}${args[0]}`, ...args);
};
export const liveCasino = (...args) => {
  return makeUrl(`${routes.root}${routes.live}`, ...args);
};
export const providers = (...args) => {
  return makeUrl(
    `/provider?${GET_PARAMS.PROVIDERS}=${args[0].join(",")}`,
    ...args,
  );
};
export const searchResult = (...args) => {
  return makeUrl(`/?${GET_PARAMS.SEARCH_RESULT}=${args.join(",")}`, ...args);
};
export const jackpot = (...args) =>
  makeUrl(`${routes.root}${routes.jackpot}`, ...args);

export const tournament = (...args) =>
  makeUrl(`${config.tournament.root}`, ...args);

export const game = (...args) =>
  makeUrl(`${routes.root}${routes.game}`, ...args);

export const sportBook = (...args) =>
  makeUrl(`${routes.root}${routes.sportBook}`, ...args);

export default {
  index,
  favorites,
  liveCasino,
  category,
  providers,
  searchResult,
  jackpot,
  game,
  tournament,
  sportBook,
};
